// import React, { useState, useEffect, useRef } from "react";
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import { loginUser } from "../APIServices/Login/loginThunk";
// import { resetAlert } from '../APIServices/alertSlice';
// import './LoginPage.css';
// import Bowser from "bowser";
// import SpinnerLoader from "../sharedFiles/loader/spinnerLoader";
// import { GetAdversitment, GetCustomerMaster, GetCustomerQRCode, Getoffers } from "../APIServices/CustomerMasterService/CustomerMasterThunk";
// // import { decryptUserInfo } from '../sharedFiles/decryption/Decryption';

// function LoginPage() {
//     // State to handle form input values and errors
//     const [username, setUsername] = useState("");
//     const [password, setPassword] = useState("");
//     const [usernameError, setUsernameError] = useState("");
//     const [passwordError, setPasswordError] = useState("");
//     const [authError, setAuthError] = useState("");  // Keep authError state for error messages (if needed)
//     const [sessionExpired, setSessionExpired] = useState(false);
//     const [isTabActive, setIsTabActive] = useState(true);
//     const userAgent = window.navigator.userAgent;
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { loading, isAuthenticated, error } = useSelector((state) => state.login);
//     const hasNavigated = useRef(false);

//     // Effect for session expiration check
//     useEffect(() => {
//         const expired = localStorage.getItem("sessionExpired") === "true";
//         setSessionExpired(expired);
//         if (expired) {
//             localStorage.removeItem("sessionExpired");
//         }
//     }, []);

//     // Handle tab visibility change
//     useEffect(() => {
//         const handleVisibilityChange = () => {
//             if (document.visibilityState === "visible") {
//                 setIsTabActive(true);
//                 if (sessionExpired && error) {
//                     Swal.fire({
//                         position: "center",
//                         icon: "error",
//                         title: "Your session has expired. Please log in again.",
//                         showConfirmButton: false,
//                         timer: 5000,
//                     }).then(() => {
//                         localStorage.removeItem("sessionExpired");
//                     });
//                     dispatch(resetAlert());
//                 }
//             } else {
//                 setIsTabActive(false);
//             }
//         };

//         document.addEventListener("visibilitychange", handleVisibilityChange);

//         return () => {
//             document.removeEventListener("visibilitychange", handleVisibilityChange);
//         };
//     }, [error, dispatch, sessionExpired]);

//     // Handle input changes and validate for character limit
//     const handleInputChange = (e, setValue, setError, characterLimit) => {
//         const inputValue = e.target.value;
//         if (inputValue.length <= characterLimit) {
//             setValue(inputValue);
//             setError(""); // Clear any previous error
//         } else {
//             setError(`Character limit exceeded. Maximum allowed: ${characterLimit}`);
//         }
//     };

//     // Handle form submission and dispatch the login action
//     const handleSubmit = (e) => {
//         e.preventDefault();
//         let hasError = false;

//         if (!username.trim()) {
//             setUsernameError("Username is required.");
//             hasError = true;
//         } else {
//             setUsernameError("");
//         }

//         if (!password.trim()) {
//             setPasswordError("Password is required.");
//             hasError = true;
//         } else {
//             setPasswordError("");
//         }

//         if (hasError) return;

//         const browser = Bowser.getParser(userAgent);
//         const body = {
//             username: username,
//             password: password,
//             DeviceInfo: JSON.stringify(browser.parsedResult)
//         }
//         dispatch(loginUser(body));
//     };

//     // Effect to navigate when the user is authenticated
//     useEffect(() => {
//         if (isAuthenticated && !hasNavigated.current) {
                      
//             hasNavigated.current = true;
//             dispatch(GetAdversitment());
//             // dispatch(Getoffers());
//             // dispatch(GetCustomerQRCode());
//             navigate("/DashBoard",{ state: { showAd: true } });
//         }
//     }, [isAuthenticated, navigate]);

//     // Effect to show error alert when authentication fails
//     useEffect(() => {
//         if (error) {
//             Swal.fire({
//                 position: "center",
//                 icon: "error",
//                 title: error,
//                 showConfirmButton: false,
//                 timer: 5000,
//             });
//         }
//     }, [error]);

//     return (
//         <>
//             <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "transparent" }}>

//                 <div className="form-container bg-white p-4 rounded shadow-sm" style={{ maxWidth: "400px", width: "100%" }}>

//                     <form onSubmit={handleSubmit}>
//                         {/* <div className='LoginHeader'>DEALER PORTAL

//                         </div> */}
//                         <img class="mb-4 mx-auto d-block" src="logo.jpeg" alt="Melwa Logo" width="120" height="90" />
//                         {/* <h1 className="h3 mb-3 fw-normal text-center">Login</h1> */}

//                         {/* Username input with validation */}
//                         <div className="form-floating mb-3">
//                             <input
//                                 type="text"
//                                 className={`form-control ${usernameError ? "is-invalid shake" : ""}`}
//                                 id="floatingUsername"
//                                 placeholder="Username"
//                                 autoComplete="off"
//                                 value={username}
//                                 onChange={(e) => handleInputChange(e, setUsername, setUsernameError, 20)}
//                                 required
//                                 style={{ outline: "none", boxShadow: "none" }}
//                             />
//                             <label htmlFor="floatingUsername">Username</label>
//                             {usernameError && <div className="invalid-feedback">{usernameError}</div>}
//                         </div>

//                         {/* Password input with validation */}
//                         <div className="form-floating mb-3">
//                             <input
//                                 type="password"
//                                 className={`form-control ${passwordError ? "is-invalid shake" : ""}`}
//                                 id="floatingPassword"
//                                 placeholder="Password"
//                                 value={password}
//                                 onChange={(e) => handleInputChange(e, setPassword, setPasswordError, 30)}
//                                 required
//                                 style={{ outline: "none", boxShadow: "none" }}
//                             />
//                             <label htmlFor="floatingPassword">Password</label>
//                             {passwordError && <div className="invalid-feedback">{passwordError}</div>}
//                         </div>

//                         {/* Submit button */}
//                         <button className="btn w-100 py-2" type="submit" style={{ backgroundColor: "#004a86", border: "none", color: "white" }}>
//                             Login
//                         </button>
//                         {loading &&<div className="loaderbg">
//                          <SpinnerLoader/>
//                         </div>}
//                         {/* Authentication error message */}
//                         {authError && <div className="alert alert-danger mt-3">{authError}</div>}
//                     </form>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default LoginPage;


import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { loginUser } from "../APIServices/Login/loginThunk";
import { resetAlert } from '../APIServices/alertSlice';
import './LoginPage.css';
import Bowser from "bowser";
import SpinnerLoader from "../sharedFiles/loader/spinnerLoader";
import { GetAdversitment, GetCustomerMaster, GetCustomerQRCode, Getoffers } from "../APIServices/CustomerMasterService/CustomerMasterThunk";

function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [authError, setAuthError] = useState("");
    const [sessionExpired, setSessionExpired] = useState(false);
    const [isTabActive, setIsTabActive] = useState(true);
    const userAgent = window.navigator.userAgent;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, isAuthenticated, error } = useSelector((state) => state.login);
    const hasNavigated = useRef(false);

    useEffect(() => {
        const expired = localStorage.getItem("sessionExpired") === "true";
        setSessionExpired(expired);
        if (expired) {
            localStorage.removeItem("sessionExpired");
        }
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setIsTabActive(true);
                if (sessionExpired && error) {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Your session has expired. Please log in again.",
                        showConfirmButton: false,
                        timer: 5000,
                    }).then(() => {
                        localStorage.removeItem("sessionExpired");
                    });
                    dispatch(resetAlert());
                }
            } else {
                setIsTabActive(false);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [error, dispatch, sessionExpired]);

    const handleInputChange = (e, setValue, setError, characterLimit) => {
        const inputValue = e.target.value;
        if (inputValue.length <= characterLimit) {
            setValue(inputValue);
            setError("");
        } else {
            setError(`Character limit exceeded. Maximum allowed: ${characterLimit}`);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let hasError = false;

        if (!username.trim()) {
            setUsernameError("Username is required.");
            hasError = true;
        } else {
            setUsernameError("");
        }

        if (!password.trim()) {
            setPasswordError("Password is required.");
            hasError = true;
        } else {
            setPasswordError("");
        }

        if (hasError) return;

        const browser = Bowser.getParser(userAgent);
        const body = {
            username: username,
            password: password,
            DeviceInfo: JSON.stringify(browser.parsedResult)
        };
        dispatch(loginUser(body));
    };

    useEffect(() => {
        if (isAuthenticated && !hasNavigated.current) {
            hasNavigated.current = true;
            dispatch(GetAdversitment());
            navigate("/DashBoard", { state: { showAd: true } });
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        if (error) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: error,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [error]);

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100" style={{ backgroundColor: '#004a86' }}>
            <div className="form-container p-5 shadow-sm rounded-4 bg-white w-100" style={{ maxWidth: "500px" }}>
                <form onSubmit={handleSubmit}>
                    <div className="text-center mb-4">
                        <img src="AstralPipes.png" alt="Logo" width="300" height="90" />
                    </div>

                    <div className="text-center mb-4">
                        <h1 className="text-danger" style={{ fontSize: '2.2rem', fontWeight:'bold' }}>MK TRADE CENTRE</h1>
                        <h5 className="text-danger" style={{ fontSize: '1.2rem', fontWeight:'bold' }}>DEALER PORTAL</h5>
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            type="text"
                            className={`form-control ${usernameError ? "is-invalid" : ""}`}
                            id="floatingUsername"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => handleInputChange(e, setUsername, setUsernameError, 20)}
                            required
                        />
                        <label htmlFor="floatingUsername">Username</label>
                        {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                    </div>

                    <div className="form-floating mb-3">
                        <input
                            type="password"
                            className={`form-control ${passwordError ? "is-invalid" : ""}`}
                            id="floatingPassword"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => handleInputChange(e, setPassword, setPasswordError, 30)}
                            required
                        />
                        <label htmlFor="floatingPassword">Password</label>
                        {passwordError && <div className="invalid-feedback">{passwordError}</div>}
                    </div>

                    <button className="btn w-100 py-2" type="submit" style={{ backgroundColor: "#004a86", border: "none", color: "white" }}>
                    {loading ? 'Logging in...' : 'Login'}
                    </button>

                    {/* Loading spinner */}
                    {/* {loading && (
                        <div className="d-flex justify-content-center mt-3">
                            <SpinnerLoader />
                        </div>
                    )} */}

                    {/* Authentication error message */}
                    {authError && <div className="alert alert-danger mt-3">{authError}</div>}
                </form>
            </div>
        </div>
    );
}

export default LoginPage;
